<div
  class="flex align-items-center flex-wrap"
  *ngIf="files?.length"
  [ngClass]="canDelete ? 'mt-3' : '-mx-2'">
  <ng-container *ngFor="let file of files | orderBy: 'file.mime:string'">
    <div
      class="p-2 relative"
      [ngClass]="{ 'mr-2 mb-2 border-1 border-round border-dashed border-200': canDelete }">
      <crm-image
        *ngIf="file.mime.includes('image/'); else documentLink"
        [preview]="false"
        [src]="'file/' + file.path | apiUrl"
        (onClickImage)="clickImage(file)"
        imageClass="w-5rem object-fit-cover aspect-ratio-1"></crm-image>
      <ng-template #documentLink>
        <crm-document-link [file]="file"></crm-document-link>
      </ng-template>

      <i
        class="pi pi-times cursor-pointer absolute text-sm text-red-500 surface-0"
        style="top: -5px; right: -5px"
        *ngIf="canDelete"
        (click)="clickDeleteFile(file)"></i>
    </div>
  </ng-container>

  <crm-galleria
    [(visible)]="visible"
    [activeImageIndex]="activeImageIndex"
    [images]="images"></crm-galleria>
</div>
